import { render, staticRenderFns } from "./VisitRequest.vue?vue&type=template&id=bdd8ed3a&scoped=true"
import script from "./VisitRequest.vue?vue&type=script&lang=js"
export * from "./VisitRequest.vue?vue&type=script&lang=js"
import style0 from "./VisitRequest.vue?vue&type=style&index=0&id=bdd8ed3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd8ed3a",
  null
  
)

export default component.exports